<mat-card-content class="d-flex flex-column justify-content-center align-items-center">
  <mat-spinner [diameter]="50" class="mt-5" />
  <p class="mt-3 mb-5 fw-bold text-black-50">Giv os et øjeblik..</p>
</mat-card-content>
